import axios from 'axios';

/** Expected when JWT/session is invalid; axios interceptor handles logout UI. */
export function isAuth401Error(error: unknown): boolean {
  return axios.isAxiosError(error) && error.response?.status === 401;
}
